import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const dataLevel = [
  {
    slug: 'toefl-primary',
    tag: ['prea1', 'a1', 'a2', 'b1'],
  },
  {
    slug: 'starters',
    tag: ['prea1'],
  },
  {
    tag: ['a1'],
    slug: 'movers',
  },
  {
    tag: ['a2'],
    slug: 'flyers',
  },
  {
    tag: ['a2', 'b1', 'b2'],
    slug: 'toefl-junior',
  },
  {
    tag: ['a2'],
    slug: 'ket',
  },
  {
    tag: ['b1'],
    slug: 'pet',
  },
  {
    tag: ['a1', 'a2'],
    slug: 'ioe',
  },
  {
    slug: 'set',
    tag: ['a1'],
  },
  {
    slug: 'ielts',
    tag: ['b1', 'b2', 'c1', 'c2'],
  },
  {
    tag: ['a2', 'b1'],
    slug: 'set-junior',
  },
];
export const baseSpeakingUrl = process.env.NEXT_PUBLIC_BASE_SPEAKING_URL as string;
export const baseSpeakingEnUrl = process.env.NEXT_PUBLIC_BASE_SPEAKING_URL_US as string;

export const searchValueAtom = atom<string | undefined>(undefined);

export const viewAll = atom<boolean>(false);

export const idCheckPointAtom = atomWithStorage<string | undefined>(
  'IdCheckPointRedirect',
  undefined,
);
export enum PracticeTab {
  MiniTest,
  Practice,
  Community,
  Mission,
  School,
}
export enum SchoolTab {
  MySchool,
  SchoolQuiz,
}
export const TOTAL_ATTENDANCE = 365;

export enum AssignTestStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  REDO = 'REDO',
}
